var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RPFilter"},[_c('RPDropdownButton',{ref:"button",attrs:{"dropdown-position":_vm.dropdownPosition,"type":_vm.type,"disabled":_vm.disabled,"default-label":_vm.defaultLabel,"default-icon":_vm.defaultIcon,"default-icon-size":_vm.defaultIconSize,"default-icon-color":_vm.defaultIconColor,"hide-arrow":_vm.hideArrow},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var open = ref.open;
var toggleDropdown = ref.toggleDropdown;
return [_vm._t("default",null,{"open":open,"toggleDropdown":toggleDropdown})]}},{key:"dropdown",fn:function(ref){
var isModal = ref.isModal;
var close = ref.close;
return [_vm._t("dropdown",null,{"isModal":isModal,"close":close})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }